import cn from 'classnames';

import { IConDefaultType } from '..';

export enum AutoPlaySetIconVariant {
  PLAY = 'play',
  PAUSE = 'pause',
  REPLAY = 'replay',
  REWIND = 'rewind',
  AUTO = 'auto',
  SPEED = 'speed',
}
interface IAutoPlaySetIconProps extends IConDefaultType {
  variant?: AutoPlaySetIconVariant;
}

export default function AutoPlaySetIcon({
  color,
  className,
  size = 40,
  rotate,
  flip,
  variant = AutoPlaySetIconVariant.PLAY,
}: IAutoPlaySetIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === AutoPlaySetIconVariant.PLAY && (
        <svg viewBox="0 0 52 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_4996_189634)">
            <path
              d="M46 22C46 33.0457 37.0457 42 26 42C14.9543 42 6 33.0457 6 22C6 10.9543 14.9543 2 26 2C37.0457 2 46 10.9543 46 22Z"
              fill="#00C3DD"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24.1041 15.0552C22.7746 14.175 21 15.1283 21 16.7228V27.2487C21 28.849 22.786 29.8012 24.1147 28.9093L32.0091 23.6102C33.1941 22.8148 33.1885 21.0699 31.9985 20.282L24.1041 15.0552Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_4996_189634"
              x="0"
              y="-1"
              width="52"
              height="52"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.764706 0 0 0 0 0.866667 0 0 0 0.30417 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4996_189634" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4996_189634" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {variant === AutoPlaySetIconVariant.PAUSE && (
        <svg viewBox="0 0 52 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_4996_189630)">
            <path
              d="M46 22C46 33.0457 37.0457 42 26 42C14.9543 42 6 33.0457 6 22C6 10.9543 14.9543 2 26 2C37.0457 2 46 10.9543 46 22Z"
              fill="#00C3DD"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M21.5 14C22.3284 14 23 14.597 23 15.3333L23 28.6667C23 29.403 22.3284 30 21.5 30C20.6716 30 20 29.403 20 28.6667L20 15.3333C20 14.597 20.6716 14 21.5 14Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M30.5 14C31.3284 14 32 14.597 32 15.3333L32 28.6667C32 29.403 31.3284 30 30.5 30C29.6716 30 29 29.403 29 28.6667L29 15.3333C29 14.597 29.6716 14 30.5 14Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_4996_189630"
              x="0"
              y="-1"
              width="52"
              height="52"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.764706 0 0 0 0 0.866667 0 0 0 0.30417 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4996_189630" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4996_189630" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {variant === AutoPlaySetIconVariant.REPLAY && (
        <svg viewBox="0 0 49 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_4996_189637)">
            <path
              d="M46 22C46 33.0457 37.0457 42 26 42C14.9543 42 6 33.0457 6 22C6 10.9543 14.9543 2 26 2C37.0457 2 46 10.9543 46 22Z"
              fill="#00C3DD"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.1558 10.8689C24.5722 10.4238 23.7383 10.5361 23.2932 11.1197C22.8481 11.7033 22.9604 12.5372 23.544 12.9823L23.8947 13.2498C22.8679 13.4968 21.8872 13.924 20.9999 14.5168C19.5198 15.5058 18.3663 16.9114 17.6851 18.5559C17.0039 20.2004 16.8257 22.01 17.1729 23.7559C17.5202 25.5017 18.3774 27.1053 19.636 28.364C20.8947 29.6227 22.4984 30.4799 24.2442 30.8271C25.99 31.1744 27.7996 30.9962 29.4442 30.315C31.0887 29.6338 32.4943 28.4802 33.4832 27.0002C34.4722 25.5201 35 23.7801 35 22.0001C35 21.1716 34.3284 20.5001 33.5 20.5001C32.6716 20.5001 32 21.1716 32 22.0001C32 23.1867 31.6481 24.3468 30.9888 25.3335C30.3295 26.3202 29.3925 27.0892 28.2961 27.5433C27.1997 27.9975 25.9933 28.1163 24.8295 27.8848C23.6656 27.6533 22.5965 27.0818 21.7574 26.2427C20.9182 25.4036 20.3468 24.3345 20.1153 23.1706C19.8838 22.0067 20.0026 20.8003 20.4567 19.704C20.9109 18.6076 21.6799 17.6705 22.6666 17.0112C23.2817 16.6002 23.9642 16.3087 24.6785 16.1474L24.3498 16.7518C23.9992 17.3966 24.2377 18.2035 24.8826 18.5541C25.5274 18.9048 26.3343 18.6662 26.6849 18.0214L28.4416 14.7906C28.7547 14.2147 28.6012 13.4965 28.08 13.099L25.1558 10.8689Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_4996_189637"
              x="0"
              y="-1"
              width="52"
              height="52"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.764706 0 0 0 0 0.866667 0 0 0 0.30417 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4996_189637" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4996_189637" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {variant === AutoPlaySetIconVariant.REWIND && (
        <svg viewBox="0 0 52 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_4996_189626)">
            <path
              d="M46 22C46 33.0457 37.0457 42 26 42C14.9543 42 6 33.0457 6 22C6 10.9543 14.9543 2 26 2C37.0457 2 46 10.9543 46 22Z"
              fill="#00C3DD"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.5 14C19.3284 14 20 14.597 20 15.3333L20 28.6667C20 29.403 19.3284 30 18.5 30C17.6716 30 17 29.403 17 28.6667L17 15.3333C17 14.597 17.6716 14 18.5 14Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M31.8959 28.9448C33.2254 29.825 35 28.8717 35 27.2772V16.7513C35 15.151 33.214 14.1988 31.8853 15.0907L23.9909 20.3898C22.8059 21.1852 22.8115 22.9301 24.0015 23.718L31.8959 28.9448Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_4996_189626"
              x="0"
              y="-1"
              width="52"
              height="52"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.764706 0 0 0 0 0.866667 0 0 0 0.30417 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4996_189626" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4996_189626" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {variant === AutoPlaySetIconVariant.AUTO && (
        <svg viewBox="0 0 53 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_4996_189620)">
            <path
              d="M43 22C43 33.0457 34.0457 42 23 42C11.9543 42 3 33.0457 3 22C3 10.9543 11.9543 2 23 2C34.0457 2 43 10.9543 43 22Z"
              fill="#8A8A8A"
            />
            <path
              d="M8.5083 27L11.6948 17.8086H14.145L17.3188 27H15.2749L14.583 24.8799H11.2568L10.5649 27H8.5083ZM14.1006 23.3945L12.9517 19.8779H12.8882L11.7393 23.3945H14.1006ZM22.7397 20.1064H24.6187V27H22.8159V25.7559H22.7397C22.5789 26.1663 22.3166 26.4922 21.9526 26.7334C21.5887 26.9704 21.1528 27.0889 20.645 27.0889C20.188 27.0889 19.7839 26.9852 19.4326 26.7778C19.0814 26.5662 18.8084 26.2658 18.6138 25.8765C18.4191 25.4871 18.3218 25.028 18.3218 24.499V20.1064H20.2007V24.1689C20.2007 24.5752 20.3086 24.8989 20.5244 25.1401C20.7445 25.3771 21.0386 25.4977 21.4067 25.502C21.6437 25.4977 21.8638 25.4406 22.0669 25.3306C22.27 25.2205 22.4329 25.0576 22.5557 24.8418C22.6784 24.626 22.7397 24.3678 22.7397 24.0674V20.1064ZM29.7095 21.5156H28.4146V24.8799C28.4103 25.138 28.4632 25.3179 28.5732 25.4194C28.6875 25.5168 28.8504 25.5697 29.062 25.5781C29.2567 25.5781 29.5063 25.5654 29.811 25.54V27.0254C29.5317 27.0677 29.1911 27.0889 28.7891 27.0889C28.0866 27.0889 27.5343 26.9281 27.1323 26.6064C26.7303 26.2806 26.5314 25.7939 26.5356 25.1465V21.5156H25.5835V20.1064H26.5356V18.4561H28.4146V20.1064H29.7095V21.5156ZM33.9116 27.1396C33.2261 27.1396 32.6273 26.9915 32.1152 26.6953C31.6074 26.3949 31.216 25.9759 30.9409 25.4385C30.6701 24.901 30.5347 24.279 30.5347 23.5723C30.5347 22.8656 30.6701 22.2456 30.9409 21.7124C31.216 21.175 31.6074 20.7581 32.1152 20.4619C32.6273 20.1657 33.2261 20.0176 33.9116 20.0176C34.5972 20.0176 35.1938 20.1657 35.7017 20.4619C36.2137 20.7581 36.6073 21.175 36.8823 21.7124C37.1616 22.2456 37.3013 22.8656 37.3013 23.5723C37.3013 24.279 37.1616 24.901 36.8823 25.4385C36.6073 25.9759 36.2137 26.3949 35.7017 26.6953C35.1938 26.9915 34.5972 27.1396 33.9116 27.1396ZM32.439 23.5723C32.439 23.9827 32.494 24.3467 32.604 24.6641C32.7183 24.9772 32.8875 25.2248 33.1118 25.4067C33.3361 25.5887 33.6069 25.6797 33.9243 25.6797C34.2332 25.6797 34.4977 25.5908 34.7178 25.4131C34.9378 25.2311 35.1029 24.9836 35.2129 24.6704C35.3271 24.3573 35.3843 23.9997 35.3843 23.5977C35.3843 23.1829 35.3293 22.8148 35.2192 22.4932C35.1092 22.1673 34.9442 21.9134 34.7241 21.7314C34.5041 21.5452 34.2375 21.4521 33.9243 21.4521C33.6069 21.4521 33.3361 21.5431 33.1118 21.7251C32.8875 21.9071 32.7183 22.1589 32.604 22.4805C32.494 22.7979 32.439 23.1618 32.439 23.5723Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_4996_189620"
              x="-7"
              y="-3"
              width="60"
              height="60"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="5" />
              <feGaussianBlur stdDeviation="5" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4996_189620" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4996_189620" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {variant === AutoPlaySetIconVariant.SPEED && (
        <svg viewBox="0 0 52 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_4996_189623)">
            <path
              d="M46 22C46 33.0457 37.0457 42 26 42C14.9543 42 6 33.0457 6 22C6 10.9543 14.9543 2 26 2C37.0457 2 46 10.9543 46 22Z"
              fill="#00C3DD"
            />
            <path
              d="M13.3872 17.8086L15.7231 21.6045H15.7993L18.1479 17.8086H19.4937L16.6118 22.4043L19.4937 27H18.1479L15.7993 23.2803H15.7231L13.3745 27H12.0288L14.9868 22.4043L12.0288 17.8086H13.3872ZM27.4282 27H25.5112V19.624H25.4604L23.353 20.9443V19.2559L25.6255 17.8086H27.4282V27ZM30.1831 27.1143C29.9884 27.1143 29.8086 27.0677 29.6436 26.9746C29.4785 26.8773 29.3473 26.7482 29.25 26.5874C29.1569 26.4224 29.1125 26.2425 29.1167 26.0479C29.1125 25.8574 29.1569 25.6818 29.25 25.521C29.3473 25.356 29.4785 25.2269 29.6436 25.1338C29.8086 25.0407 29.9884 24.9941 30.1831 24.9941C30.3693 24.9941 30.5428 25.0407 30.7036 25.1338C30.8644 25.2269 30.9935 25.356 31.0908 25.521C31.1882 25.6818 31.2368 25.8574 31.2368 26.0479C31.2368 26.2425 31.1882 26.4224 31.0908 26.5874C30.9935 26.7482 30.8644 26.8773 30.7036 26.9746C30.5428 27.0677 30.3693 27.1143 30.1831 27.1143ZM35.9214 27.127C35.1554 27.127 34.4953 26.9429 33.9409 26.5747C33.3866 26.2023 32.9613 25.6628 32.665 24.9561C32.373 24.2493 32.2271 23.3988 32.2271 22.4043C32.2271 21.4141 32.3752 20.5656 32.6714 19.8589C32.9676 19.1479 33.3929 18.6084 33.9473 18.2402C34.5016 17.8678 35.1597 17.6816 35.9214 17.6816C36.6831 17.6816 37.3411 17.8678 37.8955 18.2402C38.4499 18.6084 38.8752 19.1479 39.1714 19.8589C39.4676 20.5656 39.6157 21.4141 39.6157 22.4043C39.6157 23.403 39.4676 24.2557 39.1714 24.9624C38.8752 25.6691 38.4499 26.2065 37.8955 26.5747C37.3454 26.9429 36.6873 27.127 35.9214 27.127ZM34.1821 22.4614C34.1821 23.4771 34.3366 24.2472 34.6455 24.772C34.9544 25.2925 35.3797 25.5527 35.9214 25.5527C36.4673 25.5527 36.8947 25.2882 37.2036 24.7593C37.5125 24.2261 37.6649 23.4411 37.6606 22.4043C37.6606 21.7188 37.5908 21.1411 37.4512 20.6714C37.3115 20.1974 37.1105 19.842 36.8481 19.605C36.5858 19.368 36.2769 19.2474 35.9214 19.2432C35.3755 19.2474 34.9481 19.5225 34.6392 20.0684C34.3345 20.6143 34.1821 21.4119 34.1821 22.4614Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_4996_189623"
              x="0"
              y="-1"
              width="52"
              height="52"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.764706 0 0 0 0 0.866667 0 0 0 0.30417 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4996_189623" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4996_189623" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
    </i>
  );
}
